module.exports = __webpack_public_path__ + "static/img/soldout.2a208fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/soldout.svg
// module id = B+1J
// module chunks = 1